import React from 'react';
import './InstructionsModal.scss';

const InstructionsModalForUser = ({ isOpen, onClose, onContinue, Button }) => {
  if (!isOpen) return null;

  return (
    <div className="instructions-modal">
      <div className="instructions-content">
        <h2>Pre-Assessment Activities</h2>
        <p>
          Please ensure the following steps are completed before and during your assessment
        </p>

        <h3>Read Instructions Carefully</h3>
        <p>
          Review all instructions, guidelines, and rules thoroughly before beginning the assessment.
        </p>

        <h3>Understand the Assessment Format</h3>
        <ul>
          <li>Each assessment module contains multiple questions. After answering the questions on each page, click the <b>‘Submit & Next’</b> button to proceed.</li>
          <li>Your answers will be auto saved in the system once you click the <b>‘Submit & Next’</b> button</li>
          <li>You can choose the modules that are required for your operations and answer the listed questions.</li>
          <li>You have variety of questions like <b>Radio button, Multi Selects, Rearrange and Matrix.</b></li>
          <li>Once you click on <b>‘Submit’</b> in the final module, your assessment will be sent for evaluation and you will no longer be able to make any edits.</li>
          <li>You also can submit the feedback for each module and overall assessment at the end of each module.</li>
          <li>Kindly ensure that you complete the assessment before the given due date.</li>
        </ul>

        {/* <h3>Example</h3>
        <ul>
          <li>The Mounting & Dismounting Bearings section contains sub-modules. Your answers across these sub-modules will be saved only after completing the <b>‘Additional Insights’</b> page and clicking <b>‘Save’.</b></li>
          <li>If you exit the assessment without clicking <b>‘Save’</b> and completing the final <b>submission</b>, your responses may not be stored.</li>
        </ul> */}

        <h3>Important Notes</h3>
        <ul>
          <li>Fill in all answers carefully.</li>
          <li>Ensure you <b>complete the final submission in each module</b> to avoid losing your responses.</li>
          <li>Double-check that you’ve saved your inputs before exiting the assessment.</li>
        </ul>

        <div className="instructions-buttons">
          <Button
            title="Back"
            onClick={onClose}
            buttonStyle={{ height: '44px' }}
            titleStyle={{ fontSize: '20px', fontWeight: '600' }}
          />
          <Button
            title="Continue"
            onClick={onContinue}
            buttonStyle={{ height: '44px' }}
            titleStyle={{ fontSize: '20px', fontWeight: '600' }}
          />
        </div>
      </div>
    </div>
  );
};

export default InstructionsModalForUser;
